import React, { useState, createContext, ReactNode, useEffect } from "react";
import { generateToken } from "../config/firebase";

export interface AuthContextProps {
  fcmToken: string;
  setFcmToken: (token: string) => void;
  email: string;
  handleEmail: (value: string) => void;
  password: string;
  handlePassword: (value: string) => void;
}

interface AuthProviderProps {
  children: ReactNode;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [fcmToken, setFcmToken] = useState<string>("");

  const handleEmail = (value: string) => {
    setEmail(value);
  };

  const handlePassword = (value: string) => {
    setPassword(value);
  };

  // Call this function when you need the token, e.g., when the app loads

  useEffect(() => {
    const getToken = async () => {
      const token = await generateToken();
      if (token) {
        console.log("Token generated:", token);
        setFcmToken(token); // Set the token if it's not null
      } else {
        console.log("Token not generated or permission not granted.");
      }
    };
    getToken();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        email,
        handleEmail,
        password,
        handlePassword,
        fcmToken,
        setFcmToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
